import type { HttpErrorResponse } from '@angular/common/http'

/**
 * Returns whether the global HTTP error interceptor shows no message for this status, so the caller must show one.
 * This covers network failures and 401, 403, and 404. It does not cover calls excluded from the interceptor.
 * @param {HttpErrorResponse} error The response to check.
 * @returns {boolean}
 */
export function isGloballySilentHttpError(error: HttpErrorResponse): boolean {
  return (error.status === 0 && error.statusText === 'Unknown Error') || [401, 403, 404].includes(error.status)
}
